export const SET_REACTORS_TYPES = 'SET_REACTORS_TYPES';
export const SET_PUMP_TYPES = 'SET_PUMP_TYPES';
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
export const SET_VALIDATION_WARNINGS = 'SET_VALIDATION_WARNINGS';
